<div class="basic-container">
    <mat-spinner></mat-spinner>
    <img src="../../../../assets/logo/Logo - Cortada.png" alt="logo">
</div>
